import {Route, Routes} from 'react-router-dom';
import './App.css';
import {Batches} from './view/Batches';
import {Exceptions} from './view/Exceptions';
import {DeclarationPeriods} from './view/DeclarationPeriods';
import {FilingPacks} from './view/FilingPacks';
import {RoleProvider} from './shared/user/userRolesAccessManagement';


function App() {
    return (
        <RoleProvider>
            <div id="app_container">
                <Routes>
                    <Route path="/local-clearance/batches" element={<Batches/>}/>
                    <Route path="/local-clearance/exceptions" element={<Exceptions/>}/>
                    <Route path="/local-clearance/declaration-periods" element={<DeclarationPeriods/>}/>
                    <Route path="/local-clearance/filing-packs" element={<FilingPacks/>}/>
                </Routes>
            </div>
        </RoleProvider>
    )
}

export default App

